import { AxiosPromise } from 'axios';
import { urlsConfig } from 'src/configs';
import { urlHelper } from 'src/app/helpers';
import { axios, axiosc } from 'src/app/utils';
import { queryTypes, servicesEtmenTypes } from 'src/types';

export const etmenLookup = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
}: servicesEtmenTypes.EtmenLookupDataType): AxiosPromise<servicesEtmenTypes.EtmenLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axiosc.get(urlHelper.addQueryParameters(query, urlsConfig.generics.common.etmen), {
    blockSpinner,
  });
};
